module.exports = __webpack_public_path__ + "static/media/block-pause.dfea9f71.svg";